<template>
    <!-- CALL TO ACTION - Download / Newsletter -->
    <section class="calltoaction" id="download">
        <div class="container">
            <!-- Section Header -->
            <div class="section-header">
                <h2 class="section-title">Подписка</h2>
                <h3 class="section-subtitle">
                    Проект на стадии разработки. <br>
                    Мы можем вас уведомить, <br>
                    когда будут запущены тестовые релизы
                </h3>
            </div>
            <!-- End Section Header -->
            <!-- Section Content -->
            <div class="r1 row">
                <div class="c1 col-md-12">

                    <!-- Mailchimp Newsletter -->
                    <div class="newsletter-wrapper animateblock rtl-2 speed-1">
                        <h3>Заинтересовало? <br>
                            Подпишись на уведомления:</h3>
                        <form class="form-inline subscription-mailchimp">
                            <div class="form-group input-group input-newsletter">
                                <label class="sr-only" for="newsletter-email">Email</label>
                                <input class="form-control" id="newsletter-email" type="email"
                                       placeholder="Email">
                                <div class="input-group-btn">
                                    <button class="btn btn-danger" type="submit">Подписаться</button>
                                </div>
                            </div>
                            <small class="help-block">Обещаем не спамить. Только важное</small>
                        </form>
                        <div class="alerts alerts-newsletter"></div>
                    </div>
                    <!-- End Mailchimp Newsletter -->

                </div>
            </div>
            <!-- End Section Content -->
        </div>
    </section>
    <!-- END CALL TO ACTION -->
</template>

<script>
    export default {
        name: "CallToAction",
        data() {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// CallToAction.vue?ecd5a53e